import { Navigate } from "react-router-dom";

import { Cockpit } from "@/routes/Cockpit";
import { useAuthStatus } from "@/lib/auth";

/**
 * Root route. Bounces unauthenticated visitors to /login; otherwise
 * renders the Phase 7 cockpit. The legacy 3-bucket dashboard is
 * still available at /dashboard as the "show everything" escape
 * hatch (brief §9).
 */
export default function HomePage() {
  const auth = useAuthStatus();

  if (auth.status === "loading") {
    return (
      <main
        className="flex min-h-screen items-center justify-center bg-op-base"
        aria-busy="true"
      >
        <span className="text-sm text-op-muted">Loading…</span>
      </main>
    );
  }

  if (auth.status !== "signed_in") {
    return <Navigate to="/login" replace />;
  }

  return <Cockpit />;
}
